import { PacksService } from '../services/packs/packs.service';
import { PackModel } from '../../shared/entities/pack.model';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class PackModelRepository {
  constructor(private packModelService: PacksService) {}

  public createNewPackModel(pack?: PackModel): Observable<any> {
    return this.packModelService.postPackModel(pack!).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  public getAdminPackById(id?: string): Observable<PackModel> {
    return this.packModelService.getPackModelById(id!).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  public updateAdminPackById(id?: string, pack?: PackModel): Observable<any> {
    return this.packModelService.updatePackModelById(id!, pack!).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  public deleteAdminPacks(id: string): Observable<any> {
    return this.packModelService.deletePackModelById(id).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return of(err);
      }),
    );
  }
}
